<template>
  <div class="cm">
    <div id="cursor"></div>
    <a class="floating__btn gradientBg" @click="scrollToProduct">
      <p class="floating__btn__text">おすすめ商品をみる</p>
      <div class="floating__btn__dots"></div>
    </a>
    <figure class="bg__img">
      <AtomsConsumerImage src="/images/bakune_cm/main/bgGradient.jpg" alt="" :width="kvWidth" :lazy="false" />
    </figure>
    <main>
      <section ref="fvRef" class="section__FV">
        <figure class="FV__maincopy">
          <AtomsConsumerImage
            src="/images/bakune_cm/main/kvCopy.svg"
            alt="疲労回復は、パジャマから。"
            :width="497"
            :height="190"
            @contextmenu.prevent
            @dragstart.prevent
          />
        </figure>
        <figure class="FV__itemname">
          <AtomsConsumerImage
            src="/images/bakune_cm/main/kv_itemName.svg"
            alt="一般医療機器 BAKUNE"
            :width="569"
            :height="196"
            @contextmenu.prevent
            @dragstart.prevent
          />
        </figure>
        <figure class="FV__visual">
          <picture>
            <AtomsConsumerImage
              src="/images/bakune_cm/main/kv__visual.png"
              alt=""
              :width="kvWidth"
              class="nocopy"
              :lazy="false"
              @contextmenu.prevent
              @dragstart.prevent
            />
          </picture>
        </figure>
        <a
          id="cursorMovie"
          class="c__btn__movie btn__movie__top popup-youtube"
          data-id="klgGQm6qYz4"
          @click="openModal('klgGQm6qYz4')"
        >
          <div class="c__btn__inner">
            <div class="c__btn__text__wrap">
              <div class="c__btn__view">
                <p class="c__btn__text">CMを見る</p>
                <figure class="c__btn__icon">
                  <AtomsConsumerImage src="/images/bakune_cm/main/icon-plus.svg" alt="" :width="6" :height="7" />
                </figure>
              </div>
            </div>
          </div>
        </a>
      </section>

      <div class="interview__scroll_height"></div>
      <div class="interview__bg"></div>
      <p class="display__text__interview">SPECIAL<br />INTERVIEW</p>
      <section class="section__interview c__section">
        <div class="c__container">
          <div class="main__contents__wrap">
            <div class="c__headblock">
              <h2 class="c__subhead white ac">櫻井翔出演｜TVCM公開中</h2>
              <p class="c__leadcopy white ac"> パジャマで<br />疲労回復ができるなんて。 </p>
            </div>
            <div class="mainImage">
              <a
                id="cursorMovie02"
                class="cm__movie c__anm popup-youtube"
                data-id="klgGQm6qYz4"
                @click="openModal('klgGQm6qYz4')"
              >
                <figure class="cm__movie__thum">
                  <AtomsConsumerImage
                    src="/images/bakune_cm/main/CM_movie_thum.jpg"
                    alt=""
                    :width="1920"
                    :height="1080"
                    class="nocopy"
                    @contextmenu.prevent
                    @dragstart.prevent
                  />
                  <figure class="btn__icon">
                    <AtomsConsumerImage src="/images/bakune_cm/main/iconPlay.svg" alt="" :width="16" :height="16" />
                  </figure>
                </figure>

                <p class="movie__title c__anm">「パジャマとBAKUNE篇」15秒篇</p>
              </a>
              <a
                data-id="_mjQfKDlBhc"
                class="c__btn c__btn__white c__fit-content movie__30__btn c__anm popup-youtube"
                data-gsap-button
                @click="openModal('_mjQfKDlBhc')"
              >
                <span class="c__text__split">30秒篇はこちら</span>
              </a>
            </div>
          </div>
          <div class="making__wrap gradientBg c__padding__l__rad">
            <div class="making__inner">
              <div class="interview__contents__wrap">
                <div class="c__headblock__m">
                  <h3 class="c__leadcopy__m white ac"> メイキング映像公開中！ </h3>
                  <p class="c__bodycopy white ac"> TVCM撮影の様子を公開 </p>
                </div>
                <a
                  id="cursorMovie03"
                  data-id="EEn2O_XLuiA"
                  class="interview__wrap c__anm popup-youtube"
                  @click="openModal('EEn2O_XLuiA')"
                >
                  <figure class="btn__icon">
                    <AtomsConsumerImage src="/images/bakune_cm/main/iconPlay.svg" alt="" :width="16" :height="16" />
                  </figure>
                  <figure class="interview__thum">
                    <AtomsConsumerImage
                      src="/images/bakune_cm/main/making_movie_thum.jpg"
                      alt=""
                      class="nocopy"
                      :width="1600"
                      :height="893"
                      @contextmenu.prevent
                      @dragstart.prevent
                    />
                  </figure>
                </a>
              </div>
              <div class="profile__wrap">
                <figure class="profile__thum c__anm hidden">
                  <AtomsConsumerImage
                    src="/images/bakune_cm/main/portriat.jpg"
                    alt=""
                    :width="1599"
                    :height="1600"
                    class="c__parallax__img nocopy"
                    @contextmenu.prevent
                    @dragstart.prevent
                  />
                </figure>
                <div class="profile__text">
                  <p class="en__name white c__no__anm">SHO SAKURAI</p>
                  <p class="jp__name white c__no__anm"> 櫻井翔<span>（さくらい・しょう）</span> </p>
                  <p class="birth white c__no__anm"> 1982年1月25日生まれ<br />東京都出身 </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="section__wearing c__section c__back__filter">
        <div class="c__container_full">
          <div class="clothing__img hidden">
            <figure>
              <AtomsConsumerImage
                src="/images/bakune_cm/main/wearingImg.jpg"
                class="c__parallax__img"
                :width="1040"
                :height="1040"
              />
            </figure>
          </div>
          <div class="cart__block gradientBg">
            <div class="cart__block__inner">
              <div class="c__headblock">
                <p class="display__text c__anm">Recommend</p>
                <h2 class="c__leadcopy__s navy al">おすすめの商品</h2>
              </div>
              <div class="cart__box">
                <div class="item__tag__list">
                  <div class="item__tag">NEW</div>
                  <div class="item__tag">一般医療機器</div>
                </div>
                <div class="scroll-infinity img__list">
                  <div class="scroll-infinity__wrap">
                    <ul class="scroll-infinity__list scroll-infinity__list--left">
                      <li class="scroll-infinity__item">
                        <AtomsConsumerImage
                          src="/images/bakune_cm/main/bakuneImg01.jpg"
                          :width="882"
                          :height="1323"
                        ></AtomsConsumerImage>
                      </li>
                      <li class="scroll-infinity__item">
                        <AtomsConsumerImage
                          src="/images/bakune_cm/main/bakuneImg02.jpg"
                          :width="882"
                          :height="1323"
                        ></AtomsConsumerImage>
                      </li>
                      <li class="scroll-infinity__item">
                        <AtomsConsumerImage
                          src="/images/bakune_cm/main/bakuneImg03.jpg"
                          :width="882"
                          :height="1323"
                        ></AtomsConsumerImage>
                      </li>
                      <li class="scroll-infinity__item">
                        <AtomsConsumerImage
                          src="/images/bakune_cm/main/bakuneImg04.jpg"
                          :width="882"
                          :height="1323"
                        ></AtomsConsumerImage>
                      </li>
                    </ul>
                    <ul class="scroll-infinity__list scroll-infinity__list--left">
                      <li class="scroll-infinity__item">
                        <AtomsConsumerImage
                          src="/images/bakune_cm/main/bakuneImg01.jpg"
                          :width="882"
                          :height="1323"
                        ></AtomsConsumerImage>
                      </li>
                      <li class="scroll-infinity__item">
                        <AtomsConsumerImage
                          src="/images/bakune_cm/main/bakuneImg02.jpg"
                          :width="882"
                          :height="1323"
                        ></AtomsConsumerImage>
                      </li>
                      <li class="scroll-infinity__item">
                        <AtomsConsumerImage
                          src="/images/bakune_cm/main/bakuneImg03.jpg"
                          :width="882"
                          :height="1323"
                        ></AtomsConsumerImage>
                      </li>
                      <li class="scroll-infinity__item">
                        <AtomsConsumerImage
                          src="/images/bakune_cm/main/bakuneImg04.jpg"
                          :width="882"
                          :height="1323"
                        ></AtomsConsumerImage>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="item__detail">
                  <p class="item__title">BAKUNE Dry Men's</p>
                  <p class="item__detail">上下セット（半袖Tシャツ・ショートパンツ）</p>
                  <p class="item__info">メンズ | XS~5XL | 5カラー</p>
                  <p class="item__price">¥<span>22,820</span> 参考税込</p>
                  <button
                    class="c__btn"
                    data-gsap-button
                    @click="cartState.quickViewProductId = productRef?.document_id"
                  >
                    <span class="c__text__split">カートに追加する</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="section__feature c__section c__back__filter">
        <div class="c__container">
          <div class="stickyWrap">
            <div class="c__headblock js__feature__head">
              <h2 class="c__subhead black al c__no__anm">BAKUNEのこだわり</h2>
              <p class="c__leadcopy navy al c__no__anm"> パジャマで疲労回復できる<br />3つのこだわりの設計 </p>
              <p class="c__bodycopy black al c__no__anm">
                リカバリーウェアBAKUNEは、血行を促進し、<br />疲労回復することで健康的な<br />毎日を支える機能性パジャマ。<br />快適な眠りに特化した独自の設計で、快適な「睡眠環境」をサポートします。
              </p>
            </div>
            <div class="feature__scroll"></div>
          </div>
          <div class="research__wrap gradientBg c__anm">
            <div class="research__headblock c__headblock">
              <h2 class="c__subhead__horizon white al">BAKUNEの満足度</h2>
              <p class="c__leadcopy__m__horizon white al"> 93.8%のアスリートが<br />BAKUNEの機能性に満足! </p>
              <p class="c__bodycopy__horizon white al">
                BAKUNEは、身体のコンディションを気遣うアスリートの皆様に<br
                  class="hidden-xs"
                />ご愛用いただいております。<br
                  class="hidden-xs"
                />今まで1,000名※を超えるアスリートの方に体感いただき、<br
                  class="hidden-xs"
                />機能性についても高い評価をいただいております。
              </p>
            </div>
            <div class="research__imgWrap">
              <figure class="research__img">
                <AtomsConsumerImage
                  src="/images/bakune_cm/main/research_graph.svg"
                  :width="856"
                  :height="856"
                ></AtomsConsumerImage>
              </figure>
              <p class="research__caption">
                対象:リニューアル後のBAKUNEを提供しアンケートの回答したアスリート（n=208）2024<br />TENTIAL調べ<br />※BAKUNE（リカバリーウェア）の提供者数=1104名（リニューアル前BAKUNE含む）
              </p>
            </div>
          </div>
        </div>
      </section>
      <div class="horizon__wrap">
        <div class="feature__item">
          <p class="conut__type">01<span>/03</span></p>
          <figure class="feature__item__bg">
            <AtomsConsumerImage
              src="/images/bakune_cm/main/feature01.jpg"
              alt=""
              :width="1400"
              :height="954"
              class="hidden-xs"
            />
            <AtomsConsumerImage
              src="/images/bakune_cm/main/feature01-sp.jpg"
              alt=""
              :width="655"
              :height="1051"
              class="visible-xs"
            />
          </figure>
          <div class="c__headblock">
            <h2 class="c__subhead__horizon navy al">特殊繊維「SELFLAME®︎」</h2>
            <p class="c__leadcopy__m__horizon navy al">
              着て寝るだけで<br />
              疲労回復を促進
            </p>
            <p class="c__bodycopy__horizon black al">
              体から発せられる遠赤外線を輻射させる<br class="hidden-1200" />特殊繊維「SELFLAME®︎」を使用。<br
                class="hidden-1200"
              />血行が促進されることで、<br class="hidden-1200" />疲労回復が期待できます。
            </p>
          </div>
          <div data-v-d94f366d="" class="feature__img">
            <video
              src="https://kencoco-pro.s3.amazonaws.com/site/6mapoq6avrr-1723791881190.mp4"
              playsinline
              autoplay
              muted
              loop
              preload="auto"
              class="hidden-xs"
            ></video
            ><video
              src="https://kencoco-pro.s3.amazonaws.com/site/rnzm50wj6i-1723791881657.mp4"
              playsinline
              autoplay
              muted
              loop
              preload="auto"
              class="visible-xs"
            ></video>
          </div>
        </div>
        <div class="feature__item">
          <p class="conut__type">02<span>/03</span></p>
          <figure class="feature__item__bg">
            <AtomsConsumerImage
              src="/images/bakune_cm/main/feature02.jpg"
              alt=""
              :width="1400"
              :height="954"
              class="hidden-xs"
            />
            <AtomsConsumerImage
              src="/images/bakune_cm/main/feature02-sp.jpg"
              alt=""
              width="655"
              height="1051"
              class="visible-xs"
            />
          </figure>
          <div class="c__headblock">
            <h2 class="c__subhead__horizon navy al">寝返り特化の形状</h2>
            <p class="c__leadcopy__m__horizon navy al"> 寝返りをサポートする<br />BAKUNE Motion Design™︎ </p>
            <p class="c__bodycopy__horizon black al">
              肩や腕回りの形状を工夫し、<br class="hidden-1200" />
              寝返りを打ちやすく設計しました。<br class="hidden-1200" />
              寝返りを打つ時に服がまとわりつきにくく、<br class="hidden-1200" />
              体をスムーズに動かすことができるため、<br class="hidden-1200" />
              自然な寝返りをサポートします。
            </p>
          </div>
          <div data-v-d94f366d="" class="feature__img">
            <figure>
              <AtomsConsumerImage
                src="/images/bakune_cm/main/feature_detail02.jpg"
                alt=""
                :width="2304"
                :height="1298"
              ></AtomsConsumerImage>
            </figure>
          </div>
        </div>
        <div class="feature__item">
          <p class="conut__type">03<span>/03</span></p>
          <figure class="feature__item__bg">
            <AtomsConsumerImage
              src="/images/bakune_cm/main/feature03.jpg"
              alt=""
              :width="1400"
              :height="954"
              class="hidden-xs"
            />
            <AtomsConsumerImage
              src="/images/bakune_cm/main/feature03-sp.jpg"
              alt=""
              :width="655"
              :height="1051"
              class="visible-xs"
            />
          </figure>
          <div class="c__headblock">
            <h2 class="c__subhead__horizon navy al">消臭・防臭加工</h2>
            <p class="c__leadcopy__m__horizon navy al"> Repur®︎加工で抗菌防臭。<br />蒸れやすい季節も快眠。 </p>
            <p class="c__bodycopy__horizon black al">
              抗菌防臭・消臭効果を持つRepur®加工を施すことで、夏のイヤなニオイを消臭&予防。<br />
              ニオイの発生を元から防ぐため<br class="hidden-xs" />部屋干しでの生乾き臭も防ぎます。<br />
              また、洗濯耐性も高く、<br
                class="hidden-xs"
              />50回洗っても効果が低下しないため機能を維持したまま長く着用いただけます。
            </p>
          </div>
          <div data-v-d94f366d="" class="feature__img">
            <figure>
              <AtomsConsumerImage
                src="/images/bakune_cm/main/feature03-detail.jpg"
                alt=""
                :width="2304"
                :height="1298"
              ></AtomsConsumerImage>
            </figure>
          </div>
        </div>
      </div>
      <section class="section__cta c__section gradientBg">
        <div class="wear__img__list">
          <figure class="wear__img__item">
            <AtomsConsumerImage
              src="/images/bakune_cm/main/wearImage01.jpg"
              alt=""
              :width="2400"
              :height="2401"
            ></AtomsConsumerImage>
          </figure>
          <figure class="wear__img__item">
            <AtomsConsumerImage
              src="/images/bakune_cm/main/wearImage02.jpg"
              alt=""
              :width="2400"
              :height="1441"
            ></AtomsConsumerImage>
          </figure>
          <figure class="wear__img__item">
            <AtomsConsumerImage
              src="/images/bakune_cm/main/wearImage03.jpg"
              alt=""
              :width="2400"
              :height="1525"
            ></AtomsConsumerImage>
          </figure>
          <figure class="wear__img__item">
            <AtomsConsumerImage
              src="/images/bakune_cm/main/wearImage04.jpg"
              alt=""
              :width="2400"
              :height="2401"
            ></AtomsConsumerImage>
          </figure>
          <figure class="wear__img__item">
            <AtomsConsumerImage
              src="/images/bakune_cm/main/wearImage05.jpg"
              alt=""
              :width="4608"
              :height="2474"
            ></AtomsConsumerImage>
          </figure>
          <figure class="wear__img__item">
            <AtomsConsumerImage
              src="/images/bakune_cm/main/wearImage06.jpg"
              alt=""
              :width="2400"
              :height="1521"
            ></AtomsConsumerImage>
          </figure>
        </div>
        <div id="section__item" class="c__container">
          <div class="c__headblock">
            <h2 class="c__subhead navy ac"> 寝ている間に、効率的に疲労を回復。 </h2>
            <p class="c__leadcopy navy ac"> 疲労回復パジャマBAKUNEを<br />はじめてみませんか？ </p>
            <p class="c__bodycopy black ac">
              暖かくなるこの時期におすすめなのは、サラッとした着心地が人気のドライタイプ。<br
                class="hidden-xs"
              />豊富なカラーバリエーションから、あなたの好きな色を見つけて下さい。
            </p>
          </div>
          <div class="cart__parts">
            <figure>
              <PagePartsCart
                v-if="productRef"
                :id="`page_parts_64f7df0b3c023b563b812d17`"
                ref="PagePartsCartRef"
                :product="productRef"
                :list-parts="[]"
                :subtitle="''"
                :description="''"
                :index="0"
                :cart-index="0"
                :page-type="''"
                class="page-parts-section"
                :delivery-lt-prefectures="deliveryLtPrefectures"
              />
            </figure>
          </div>
          <div class="lineup__wrap">
            <div class="c__headblock">
              <h2 class="c__subhead navy ac c__no__anm">多様な素材で、年中着れる</h2>
              <p class="c__leadcopy navy ac c__no__anm"> 着心地にこだわった<br />豊富なラインナップ展開 </p>
              <p class="c__bodycopy black ac c__no__anm">
                疲労回復の機能はそのまま、<br
                  class="hidden-xs"
                />すべてのお客様にオールシーズン着用いただきたいという思いから、<br
                  class="hidden-xs"
                />さまざまな生地や形状のリカバリーウェアを取り揃えています。
              </p>
              <a
                href="https://tential.jp/features/howtochoose_recoverywear_sleepitem"
                class="c__btn c__fit-content c__anm c__no__anm"
                data-gsap-button
              >
                <span class="c__text__split">詳しくはこちら </span>
              </a>
            </div>
            <div class="line__up__img__wrap">
              <div class="line__up__img__row__01 line__up__img__row">
                <div class="line__up__img__col__01 line__up__img__col">
                  <figure class="line__up__img__01 line__up__img">
                    <AtomsConsumerImage
                      src="/images/bakune_cm/main/lineup1.jpg"
                      :width="900"
                      :height="570"
                      class="c__parallax__img"
                    ></AtomsConsumerImage>
                  </figure>
                  <figure class="line__up__img__02 line__up__img">
                    <AtomsConsumerImage
                      src="/images/bakune_cm/main/lineup2.jpg"
                      :width="432"
                      :height="273"
                      class="c__parallax__img"
                    ></AtomsConsumerImage>
                  </figure>
                </div>
                <div class="line__up__img__col__02 line__up__img__col">
                  <figure class="line__up__img__03 line__up__img">
                    <AtomsConsumerImage
                      src="/images/bakune_cm/main/lineup3.jpg"
                      :width="1212"
                      :height="768"
                      class="c__parallax__img"
                    ></AtomsConsumerImage>
                  </figure>
                  <figure class="line__up__img__04 line__up__img">
                    <AtomsConsumerImage
                      src="/images/bakune_cm/main/lineup4.jpg"
                      :width="756"
                      :height="405"
                      class="c__parallax__img"
                    ></AtomsConsumerImage>
                  </figure>
                </div>
              </div>
              <div class="line__up__img__row__02 line__up__img__row">
                <div class="line__up__img__col__03 line__up__img__col">
                  <figure class="line__up__img__05 line__up__img">
                    <AtomsConsumerImage
                      src="/images/bakune_cm/main/lineup5.jpg"
                      :width="840"
                      :height="870"
                      class="c__parallax__img"
                    ></AtomsConsumerImage>
                  </figure>
                  <figure class="line__up__img__06 line__up__img">
                    <AtomsConsumerImage
                      src="/images/bakune_cm/main/lineup6.jpg"
                      :width="428"
                      :height="426"
                      class="c__parallax__img"
                    ></AtomsConsumerImage>
                  </figure>
                </div>
                <div class="line__up__img__col__04 line__up__img__col">
                  <figure class="line__up__img__07 line__up__img">
                    <AtomsConsumerImage
                      src="/images/bakune_cm/main/lineup7.jpg"
                      :width="1344"
                      :height="729"
                      class="c__parallax__img"
                    ></AtomsConsumerImage>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="section__tential c__section">
        <div class="sectionBg">
          <figure class="sectionBg__img hidden">
            <AtomsConsumerImage
              src="/images/bakune_cm/main/tentialBg.jpg"
              :width="3200"
              :height="1152"
            ></AtomsConsumerImage>
          </figure>
        </div>
        <div class="c__container">
          <div class="c__headblock">
            <h2 class="c__subhead white al c__no__anm">About TENTIAL</h2>
            <p class="c__leadcopy white al c__no__anm"> コンディショニングと向き合う<br />TENTIAL </p>
            <p class="c__bodycopy white al c__no__anm">
              健康に前向きな社会を創り、人類のポテンシャルを引き出す。を掲げて、<br
                class="hidden-xs"
              />様々なプロダクトを開発しています。
            </p>
            <a href="https://corp.tential.jp/" class="c__btn c__btn__white c__fit-content c__no__anm" data-gsap-button>
              <span class="c__text__split">TENTIALについてはこちら</span>
            </a>
          </div>
        </div>
      </section>
    </main>
    <div v-if="isModalVisible" class="cm-modal" @click="closeModal">
      <div class="overlay"></div>
      <div class="movie-wrap" @click.stop>
        <iframe
          :src="`https://www.youtube-nocookie.com/embed/${currentVideoId}?rel=0&autoplay=0`"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          referrerpolicy="strict-origin-when-cross-origin"
        ></iframe>
        <button title="Close (Esc)" type="button" class="cm-modal-close" @click="closeModal">×</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// @ts-nocheck
/* eslint-disable */
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import Lenis from "lenis"
import { sleep } from "@tential/ec-gql-schema/utils/functions/common"
import { Product, PublicLogilessOutboundDeliveryCalcDeliveryLtPrefecturesQuery } from "~/types/type.generated"
import {
  usePublicLogilessOutboundDeliveryCalcDeliveryLtPrefecturesQuery,
  usePublicProductFindOneQuery,
} from "~/gql/urql.generated"
import PagePartsCart from "~/components/pageParts/Cart.vue"
import { useStore } from "~/stores"
import { useCart } from "~/composables/useCart"

const store = useStore()
const { cartState } = useCart()

const { width: windowWidth } = useWindowSize()
const kvWidth = computed(() => (windowWidth.value > 768 ? 1920 : 768))

const PagePartsCartRef = ref<InstanceType<typeof PagePartsCart>>()

// GSAP ScrollTrigger の初期化
gsap.registerPlugin(ScrollTrigger)

let lenis: Lenis | null = null
let tickerCallback: ((time: number) => void) | null = null

const initSmoothScrolling = () => {
  lenis = new Lenis({ lerp: 0.15 })

  lenis.on("scroll", ScrollTrigger.update)

  tickerCallback = (time) => {
    lenis?.raf(time * 1000)
  }

  gsap.ticker.add(tickerCallback) // Add ticker callback
  gsap.ticker.lagSmoothing(0)
}

const destroySmoothScrolling = () => {
  if (lenis) {
    lenis.destroy() // Destroy Lenis instance
    lenis = null
  }
  if (tickerCallback) {
    gsap.ticker.remove(tickerCallback) // Remove the ticker callback
    tickerCallback = null
  }
}

// スプラッシュアニメーションの設定
const splashAnimations = [
  { className: "is-splash01", delay: 500 },
  { className: "is-splash02", delay: 1000 },
  { className: "is-splash03", delay: 1600 },
  { className: "is-splash04", delay: 2000 },
]

// スプラッシュアニメーションの実行
splashAnimations.forEach(({ className, delay, refresh }) => {
  setTimeout(() => {
    document.documentElement.classList.add(className)
    if (refresh) {
      ScrollTrigger.refresh()
    }
  }, delay)
})

const isModalVisible = ref(false)
const currentVideoId = ref<string | null>(null)

const openModal = (videoId: string) => {
  currentVideoId.value = videoId
  isModalVisible.value = true
}

const closeModal = () => {
  isModalVisible.value = false
  currentVideoId.value = null
}

const cursor = ref<HTMLElement | null>(null)

const productRef = ref<Product | null>(null)
const deliveryLtPrefectures = ref<
  PublicLogilessOutboundDeliveryCalcDeliveryLtPrefecturesQuery["publicLogilessOutboundDeliveryCalcDeliveryLtPrefectures"]
>({
  default_prefecture: "",
  prefectures: [],
})

const scrollToProduct = () => {
  document.querySelector("#section__item")?.scrollIntoView({
    behavior: "smooth",
  })
}

const loadProduct = async () => {
  const [{ data: product }, { data: calcDeliveryLtPrefecturesData }] = await Promise.all([
    usePublicProductFindOneQuery({
      requestPolicy: "network-only",
      variables: {
        filter: {
          document_id: "67ca6adcce9a365145b38d0c",
          is_status: true,
        },
      },
    }),
    usePublicLogilessOutboundDeliveryCalcDeliveryLtPrefecturesQuery({
      requestPolicy: "cache-first",
    }),
  ])

  productRef.value = product?.value?.publicProductFindOne as Product

  deliveryLtPrefectures.value = calcDeliveryLtPrefecturesData.value
    ?.publicLogilessOutboundDeliveryCalcDeliveryLtPrefectures ?? {
    default_prefecture: "",
    prefectures: [],
  }
}

const fvRef = ref<HTMLElement | null>(null)

const setFvHeight = (): void => {
  const fvElement = fvRef.value
  const headerElement = document.getElementById("site-header-id")
  if (!fvElement || !headerElement) return
  const headerHeight = headerElement.clientHeight
  fvElement.style.height = `calc(100svh - ${headerHeight}px)`
}

const useButtonAnimation = () => {
  const buttons = document.querySelectorAll<HTMLElement>("[data-gsap-button]")

  buttons.forEach((button) => {
    // テキストを分割
    const textWrapper = button.querySelector(".c__text__split") as HTMLElement
    const text = textWrapper.textContent || ""
    const splitText = [...text]
      .map((char) => `<span class="char" style="display: inline-block;">${char}</span>`)
      .join("")
    textWrapper.innerHTML = splitText

    // アニメーション状態の管理
    let isAnimating = false

    // ホバーイベントの設定
    button.addEventListener("mouseenter", () => {
      if (isAnimating) return
      isAnimating = true

      const chars = textWrapper.querySelectorAll<HTMLElement>(".char")
      const tl = gsap.timeline()

      tl.to(chars, {
        yPercent: -120,
        duration: 0.5,
        ease: "power3.inOut",
        stagger: {
          amount: 0.3,
          ease: "power2.in",
        },
        opacity: 0,
      })
        .set(chars, {
          yPercent: 80,
          opacity: 0,
        })
        .to(chars, {
          yPercent: 0,
          duration: 0.5,
          ease: "power2.out",
          stagger: {
            amount: 0.3,
            ease: "power2.out",
          },
          opacity: 1,
          onComplete: () => {
            isAnimating = false
          },
        })
    })
  })
}

onMounted(async () => {
  await loadProduct()
  await setFvHeight()
  await sleep(500) // Imageが読み込まれて完全な高さを計算するために少し待つ
  // レスポンシブ対応のアニメーション設定
  ScrollTrigger.matchMedia({
    // PC
    "(min-width: 1200px)": function () {
      ScrollTrigger.create({
        trigger: ".interview__scroll_height",
        start: "top top",
        end: "top -50%",
        scrub: 1,
        onUpdate: (self) => {
          const topEdge = gsap.utils.interpolate(100, 0, self.progress) // 下から上へ
          const bottomEdge = gsap.utils.interpolate(100, 100, self.progress) // 下端は固定

          const clipPath = `polygon(0% ${topEdge}%, 100% ${topEdge}%, 100% ${bottomEdge}%, 0% ${bottomEdge}%)`
          gsap.set(".interview__bg", {
            clipPath,
          })
        },
      })
      // 新しいアニメーション - セクション切り替え時の背景とテキストの非表示
      ScrollTrigger.create({
        trigger: ".section__wearing",
        start: "center top",
        end: "center -5%",
        scrub: 1,
        onUpdate: (self) => {
          // テキストの拡大と透明化
          const scale = gsap.utils.interpolate(1, 1.5, self.progress)
          const opacity = gsap.utils.interpolate(0.1, 0, self.progress)
          gsap.set(".display__text__interview", {
            scale,
            opacity,
            x: "-50%",
            y: "-50%",
            transformOrigin: "center center",
          })

          // 背景の下から上へのクリップ
          // clipEndを0から100に変化させることで、下から上へのトリミング効果を作成
          const clipStart = gsap.utils.interpolate(0, 0, self.progress) // 上端は0%で固定
          const clipEnd = gsap.utils.interpolate(100, 0, self.progress) // 下端が100%から0%に変化
          const clipPath = `polygon(0% ${clipStart}%, 100% ${clipStart}%, 100% ${clipEnd}%, 0% ${clipEnd}%)`
          gsap.set(".interview__bg", {
            clipPath,
          })
        },
      })
      const fadeElements = document.querySelectorAll(".line__up__img")
      fadeElements.forEach((element) => {
        gsap.to(element, {
          scrollTrigger: {
            trigger: element,
            start: "top -50%",
            end: "top -100%",
            scrub: true,
          },
          opacity: 0,
        })
      })
    },

    // タブレット・スマートフォン
    "(max-width: 1199px)": function () {
      // 最初のアニメーション - 背景とテキストの表示
      ScrollTrigger.create({
        trigger: ".interview__scroll_height",
        start: "top top",
        end: "top -50%",
        scrub: 1,
        onUpdate: (self) => {
          const topEdge = gsap.utils.interpolate(100, 0, self.progress) // 下から上へ
          const bottomEdge = gsap.utils.interpolate(100, 100, self.progress) // 下端は固定

          const clipPath = `polygon(0% ${topEdge}%, 100% ${topEdge}%, 100% ${bottomEdge}%, 0% ${bottomEdge}%)`
          gsap.set(".interview__bg", {
            clipPath,
          })
        },
      })
      const fadeElements = document.querySelectorAll(".line__up__img")
      fadeElements.forEach((element) => {
        gsap.to(element, {
          scrollTrigger: {
            trigger: element,
            start: "top 20%",
            end: "top -40%",
            scrub: true,
          },
          opacity: 0,
        })
      })
      ScrollTrigger.create({
        trigger: ".section__wearing",
        start: "top 30%",
        end: "top 10%",
        toggleActions: "play reverse play reverse",
        scrub: 1,
        onUpdate: (self) => {
          // テキストの拡大と透明化
          const scale = gsap.utils.interpolate(1, 1.5, self.progress)
          const opacity = gsap.utils.interpolate(0.1, 0, self.progress)
          gsap.set(".display__text__interview", {
            scale: scale,
            opacity: opacity,
            x: "-50%",
            y: "-50%",
            transformOrigin: "center center",
          })

          // 背景の下から上へのクリップ
          // clipEndを0から100に変化させることで、下から上へのトリミング効果を作成
          const clipStart = gsap.utils.interpolate(0, 0, self.progress) // 上端は0%で固定
          const clipEnd = gsap.utils.interpolate(100, 0, self.progress) // 下端が100%から0%に変化
          const clipPath = `polygon(0% ${clipStart}%, 100% ${clipStart}%, 100% ${clipEnd}%, 0% ${clipEnd}%)`
          gsap.set(".interview__bg", {
            clipPath: clipPath,
          })
        },
      })
    },

    // 共通のアニメーション
    all: function () {
      // 全デバイス共通のアニメーション
      // floatingBtn
      ScrollTrigger.create({
        trigger: ".section__interview",
        start: "top center",
        end: "+=99999",
        toggleClass: {
          targets: ".floating__btn",
          className: "is-view",
        },
      })
      ScrollTrigger.create({
        trigger: ".section__tential",
        start: "bottom center",
        end: "+=99999",
        toggleClass: {
          targets: ".floating__btn",
          className: "is-hidden",
        },
      })
      // 横スクロールのアニメーション
      gsap.to(".horizon__wrap", {
        left: () => {
          const horizonWidth = document.querySelector(".horizon__wrap")?.offsetWidth
          const windowWidthTenPercent = window.innerWidth * 0.1 // 画面幅の10%
          return -(horizonWidth + windowWidthTenPercent) + "px"
        },
        scrollTrigger: {
          trigger: ".feature__scroll",
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      })
      gsap.to(".wear__img__list", {
        transform: "translateX(-30%)",
        scrollTrigger: {
          trigger: ".wear__img__list",
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      })
      // 共通アニメーション
      const createScrollAnimation = (startPosition) => ({
        scrollTrigger: {
          start: `top ${startPosition}`,
          end: "+=9999%",
          duration: 0.3,
          toggleActions: "play reverse play reverse",
        },
        opacity: 0,
        scale: 1.05,
        transform: "translateY(20px) translateX(20px)",
      })

      // アニメーション対象要素の設定
      const animations = [
        {
          selector: ".c__subhead",
          startPosition: "87%",
        },
        {
          selector: ".c__leadcopy, .c__leadcopy__m, .c__leadcopy__s",
          startPosition: "85%",
        },
        {
          selector: ".c__bodycopy",
          startPosition: "83%",
        },
        {
          selector: ".c__anm",
          startPosition: "83%",
        },
      ]

      // パララックスアニメーションの基本設定
      const parallaxConfigs = [
        {
          selector: ".c__parallax__img", // 標準的な画像用
          translateY: 30,
          scale: 1.1,
        },
        {
          selector: ".c__parallax__img--slow", // ゆっくり動く画像用
          translateY: 20,
          scale: 1.05,
        },
        {
          selector: ".c__parallax__img--fast", // 速く動く画像用
          translateY: 50,
          scale: 1.15,
        },
      ]

      // パララックスアニメーションの作成
      parallaxConfigs.forEach(({ selector, translateY, scale }) => {
        gsap.utils.toArray(selector).forEach((target) => {
          // 画像の初期スケールを設定
          gsap.set(target, {
            scale,
          })

          // スクロールアニメーションの設定
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: target,
              start: "top bottom", // 要素の上端がビューポートの下端に来たとき
              end: "bottom top", // 要素の下端がビューポートの上端に来たとき
              scrub: 1, // スムーズなスクロール追従（1秒のスムージング）
              toggleActions: "play reverse play reverse",
              markers: false, // デバッグ時はtrueに設定
            },
          })

          // タイムラインにアニメーションを追加
          tl.fromTo(
            target,
            {
              y: -translateY / 2, // 開始位置
              scale,
            },
            {
              y: translateY / 2, // 終了位置
              scale: scale * 0.95, // わずかに縮小
              ease: "none",
            },
          )
        })
      })

      // オプション：Intersection Observerを使用してパフォーマンス最適化
      const observerOptions = {
        root: null,
        rootMargin: "50px",
        threshold: 0,
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (
            entry.target.classList.contains("c__parallax__img") ||
            entry.target.classList.contains("c__parallax__img--slow") ||
            entry.target.classList.contains("c__parallax__img--fast")
          ) {
            if (entry.isIntersecting) {
              entry.target.style.willChange = "transform"
            } else {
              entry.target.style.willChange = "auto"
            }
          }
        })
      }, observerOptions)

      // 全てのパララックス要素を監視
      document
        .querySelectorAll(".c__parallax__img, .c__parallax__img--slow, .c__parallax__img--fast")
        .forEach((img) => observer.observe(img))

      // アニメーションの適用
      animations.forEach(({ selector, startPosition }) => {
        gsap.utils.toArray(selector).forEach((target) => {
          gsap.from(target, {
            ...createScrollAnimation(startPosition),
            scrollTrigger: {
              ...createScrollAnimation(startPosition).scrollTrigger,
              trigger: target,
            },
          })
        })
      })

      const finishAboutHeaderClipReveal = window.innerHeight

      ScrollTrigger.create({
        trigger: ".interview__scroll_height",
        start: "25% top",
        end: `+=${finishAboutHeaderClipReveal}`,
        scrub: 1,
        onUpdate: (self) => {
          const scale = gsap.utils.interpolate(0.75, 1, self.progress)
          const opacity = gsap.utils.interpolate(0, 0.1, self.progress)
          gsap.set(".display__text__interview", {
            scale,
            opacity,
            x: "-50%",
            y: "-50%",
            transformOrigin: "center center",
          })
        },
      })
      gsap.to(".js__feature__head", {
        autoAlpha: "0",
        scrollTrigger: {
          trigger: ".feature__scroll",
          start: "top 50%",
          end: "top 0%",
          scrub: true,
        },
      })
    },
  })
  let initialWidth = window.innerWidth
  window.addEventListener("resize", function () {
    const currentWidth = window.innerWidth
    if (currentWidth > 767 && initialWidth <= 767) {
      location.reload()
    }
    if (currentWidth < 767 && initialWidth >= 767) {
      location.reload()
    }
    initialWidth = currentWidth
  })

  // Cursor Animation
  cursor.value = document.getElementById("cursor")
  if (cursor.value) {
    // マウス移動イベントを設定してカーソル位置を更新
    document.addEventListener("mousemove", (e) => {
      const x = e.clientX
      const y = e.clientY
      cursor.value!.style.top = `${y}px`
      cursor.value!.style.left = `${x}px`
    })

    // IDが"cursor"で始まるすべての要素に対してマウスイベントを設定
    document.querySelectorAll<HTMLElement>("[id^='cursor']").forEach((element) => {
      element.addEventListener("mouseenter", () => {
        cursor.value!.classList.add(`is-${element.id}`)
      })
      element.addEventListener("mouseleave", () => {
        cursor.value!.classList.remove(`is-${element.id}`)
      })
    })
  }

  useButtonAnimation()
  initSmoothScrolling()
  await nextTick()
  ScrollTrigger.refresh()
})

onUnmounted(() => {
  destroySmoothScrolling()
  ScrollTrigger.getAll().forEach((trigger) => {
    trigger.kill()
  })
})
</script>

<style lang="scss" scoped>
@import "assets/scss/pages/bakune_cm/main";
.cm-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 101;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 24px;

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    display: block;
    width: 100%;
    height: 100%;
    background: #0b0b0b;
    opacity: 0.8;
  }
  .movie-wrap {
    position: relative;
    height: 0;
    width: 100%;
    max-width: 80%;
    margin: auto;
    z-index: 10;
    max-width: 800px;
    max-height: 450px;
    height: 450px;
    @include tab {
      padding-bottom: 56.25%;
      height: auto;
      width: 95%;
      max-width: 100%;
    }
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .cm-modal-close {
    position: absolute;
    top: -24px;
    right: -8px;
    opacity: 0.65;
    color: #fff;
    font-size: 34px;
  }
}
.cart__parts {
  background: #e7ebf2;
  padding: 56px;
  border-radius: 20px;
  @include tab {
    padding: 1rem;
    border-radius: 0.375rem;
  }
}
img {
  pointer-events: none;
  -webkit-touch-callout: none;
  -moz-touch-callout: none;
  touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  user-select: none;
}
</style>
